export const selectSelectedTheme = state => state?.selectedTheme
export const selectSelectedLanguage = state => state?.selectedLanguage
export const selectShowInheritedRoles = state => state?.showInheritedRoles
